module.exports = __webpack_public_path__ + "img/tree.a29f77df.png";